import stream from './Stream.json';
import nftsAbi from './NFTs.json';
import erc20 from './ERC20.json';

import {
  getNFTAddr,
  getContract,
  callContract,
  getCurrentAccountAddr,
  writeContract,
  getTokenContract,
  convertAmount,
  getStreamAddr,
} from '../../utils/web3';

import { APPROVE_LIMIT } from '../../config/constants';

// stream contract api
export const streamApi = () => {
  const contractAddress = getStreamAddr();
  const contract = getContract(contractAddress, stream.abi);

  // query
  const getStreamInfo = async (streamId: number) => {
    const res = await callContract(contract, 'getStreamInfo', [streamId]);
    return res;
  };

  const getClaimable = async (streamId: number, tokenId: number) => {
    const res = await callContract(contract, 'availableBalanceForTokenId', [streamId, tokenId]);
    return res;
  };

  const getRemain = async (streamId: number, tokenId: number) => {
    const res = await callContract(contract, 'remainingBalanceByTokenId', [streamId, tokenId]);
    return res;
  };

  // ====== write

  // Claim all with multi nft ids
  const claimAll = async (streamId: number, tokenIds = [], cbs: any) => {
    const res = await writeContract(contract, 'withdrawAllFromStream', [streamId, tokenIds], cbs);
    return res;
  };

  // staking token to pool
  const claimByNFT = async (streamId: number, tokenId: number, cbs: any) => {
    const res = await writeContract(
      contract,
      'withdrawFromStreamByTokenId',
      [streamId, tokenId],
      cbs,
    );
    return res;
  };

  return {
    ...contract,
    getStreamInfo,
    getClaimable,
    getRemain,
    claimAll,
    claimByNFT,
  };
};

// ERC721 API
export const nftsApi = () => {
  const contractAddress = getNFTAddr();
  const contract = getContract(contractAddress, nftsAbi);

  // query 1155 token
  const getCardBal = async (tokenId: number, addr: string) => {
    const address = addr || (await getCurrentAccountAddr());
    const res = await callContract(contract, 'balanceOf', [address, tokenId]);
    return res;
  };
  // query 1155 token
  const getCardLimt = async (tokenId: number) => {
    const res = await callContract(contract, 'maxSupply', [tokenId]);
    return res;
  };
  // query 1155 token total supply
  const getCardTotalSupply = async (tokenId: number) => {
    const res = await callContract(contract, 'totalSupply', [tokenId]);
    return res;
  };

  // query approve from contract
  const isApprovedForAll = async (contractAddr: string, addr?: string) => {
    const address = addr || (await getCurrentAccountAddr());
    const res = await callContract(contract, 'isApprovedForAll', [address, contractAddr]);
    return res;
  };

  // ===== write ======

  // approve from contract
  const setApprovalForAll = async (contractAddr: string, cbs: any) => {
    const res = await writeContract(contract, 'setApprovalForAll', [contractAddr, true], cbs);
    return res;
  };

  return {
    ...contract,
    getCardBal,
    getCardLimt,
    getCardTotalSupply,
    isApprovedForAll,
    setApprovalForAll,
  };
};

// ERC20 API
export const tokenApi = (name = '') => {
  const symbol = name.toUpperCase();
  const tokenAddr = getTokenContract(symbol);
  const contract = getContract(tokenAddr, erc20.abi);

  // query balance of erc20 token
  const getBalance = async (addr = '') => {
    const address = addr || (await getCurrentAccountAddr());
    const res = await callContract(contract, 'balanceOf', [address]);
    return res;
  };

  // get approve amount with address
  const getAllowance = async (contractAddr: string) => {
    const address = await getCurrentAccountAddr();
    const res = await callContract(contract, 'allowance', [address, contractAddr]);
    return res;
  };

  // get total supply
  const totalSupply = async () => {
    const res = await callContract(contract, 'totalSupply', []);
    return res;
  };

  // approve token to address
  const approve = async (contractAddr: string, cbs: any, amount = APPROVE_LIMIT) => {
    const res = await writeContract(contract, 'approve', [contractAddr, amount], cbs);
    return res;
  };

  return { ...contract, getBalance, getAllowance, approve, totalSupply };
};

export default {};
